import Image from 'app/Components/Shared/Image/image';
import React from 'react'
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit'
import {getPdfLogAuthAsync }from '../../PersonalAreaInvoicesAsyncThunk'
import { connect } from 'react-redux';
import Config from '../../../../../Config';
import { prepareSameWindowUrlWithNavigateTo } from '../../../../../utilities/StringHelpers/StringHelpers';
import { openBase64ToPdfFile } from '../../helper/helper';

function AnnualInvoiceConsolidationPopup(props) {
  const billingCycleDay = props.annualInvoiceConsolidation?.consolidationPdfYears?.consolidationMonth;
  const invoiceMonthName = billingCycleDay === 2 ? 'פברואר' : 'מרץ';

  const btnText = <span><Image src={require('../../icons/download-white.svg')} />להורדת ריכוז חשבוניות {props.annualInvoiceConsolidation.consolidationPdfYears.consolidationYear}</span>

  const onHandleClick = ()=>{
    openBase64ToPdfFile(props.annualInvoiceConsolidation.pdfBase64);
    props.setShowPopUp(false);
  }


  return (
    <div className='consolidation-popup'>
       <Image width={'60px'} height={'60px'} src={require('../../icons/file.svg')} />
       <div className='title'>ריכוז חשבוניות</div>
        <div className='subTitle gray'>
            לידיעתך, ריכוז חשבוניות הינו חלק
            מחשבונית {invoiceMonthName} ומופיע בסוף החשבונית</div>

         <BtnSubmit text={btnText} onclick={onHandleClick} ></BtnSubmit>

        <div className='subTitle'>מסמך ריכוז חשבוניות לשנת {props.annualInvoiceConsolidation.consolidationPdfYears.consolidationNextYear} יופק ויהיה זמין להורדה <span className='bold'> בחודש {invoiceMonthName} {props.annualInvoiceConsolidation.consolidationPdfYears.thirdYear}</span>   </div>
        {/* <div className='purpleLink'  onClick={() => {prepareSameWindowUrlWithNavigateTo(Config.lobbyUrl)} }>חזרה לאזור האישי</div> */}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    billingCycle: state.personalAreaInvoicesPage.invoicesInfo?.main?.billingCycle,
  };
};
const mapDispatchToProps = {
  getPdfLogAuthAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnualInvoiceConsolidationPopup);
